import { lazy } from "react";
import { administratorRoles } from "../../config/roles";
import { PageAction } from "../recordDefinition.types";
import { isActiveAccount } from "./actions/accountActionHelpers";

// Lazy, as contact's are, so the legacy status modal loads only when it is opened.
const AccountStatusModal = lazy(() => import("./actions/AccountStatusModal"));

export const accountPageActions: PageAction[] = [
  {
    id: "set-status",
    label: (record) =>
      isActiveAccount(record) ? "Deactivate Account" : "Activate Account",
    roles: administratorRoles,
    modal: AccountStatusModal,
  },
];
